import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteImagensParceiro(id: string) {
  return useMutation(
    `/v1/parceiro/imagens/deletar`,
    (arquivoId: string) =>
      http.delete(
        `/v1/parceiro/${id}/imagens/${arquivoId}`
      ),
    { retry: false }
  );
}

export default useDeleteImagensParceiro;
